<template>
  <div class="shopCardList" style="width: 100%; display: block; box-shadow: none;">
    <div style="position: relative;">
      <div style="margin: 0;width: 100%;height: 100%;display: flex;">
        <div style="position: relative; width: 19.2vw; height: 19.2vw; display: inline-block;border-radius: .8vw; overflow: hidden">
          <div style="background-color: #ffffff; height: 100%; width: 100%">
            <img :src="row.imgPath || row.containerLoadImg" style="width: 100%; height: 100%; -webkit-touch-callout: none; -webkit-user-select: none; user-select: none;">
          </div>
        </div>
        <div class="shopListInfo">
          <div style="font-size: 3.73vw; width: 55vw; margin-top: .8vw;font-weight: bold">
            {{row.containerLoadName}}
          </div>
          <div style="justify-content: left;margin-top: 2vw;color: #9f9f9f;font-size: 2.67vw">
            最低购买量: {{row.miniBuyQty || 0}}
          </div>
        </div>
      </div>
      <div @click="expend(row)" style="position: absolute;bottom: .9vw;right: 3.5vw;width: 4vw;height: 4vw">
        <van-icon v-show="!row.show" color="#666" style="font-size: 4vw" name="arrow-down" />
        <van-icon v-show="row.show" color="#666" style="font-size: 4vw" name="arrow-up" />
      </div>
    </div>
    <div style="width: 100%">
<!--      分类附属品 加修改订单-->
      <span v-if="row.shopGoodsVOList && row.shopGoodsVOList[0] !== null && row.show" style="font-weight: 700">拼箱商品</span>
      <div v-if="row.shopGoodsVOList && row.shopGoodsVOList[0] !== null && row.show">
        <div v-for="item in row.shopGoodsVOList" :key="item.id" style="width: 100%;height: 8vw;line-height: 8vw;position: relative;margin: 2vw 0 0">
          <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw">
            <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%; -webkit-touch-callout: none; -webkit-user-select: none; user-select: none; ">
          </span>
          <span style="font-weight: 700;font-size: 3vw;margin-left: 10vw;width: 32vw;display: inline-block;overflow: hidden;display: inline-block;height: 7vw">{{item.goodsName}}</span>
          <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 43vw">￥{{item.price/100}}</span>
          <div style="position: absolute; right: 4.8vw;bottom: 0vw;" class="shopListStepper">
            <van-stepper
              v-model="item.buyQty"
              input-width="6.67vw"
              button-size="3.73vw"
              integer
              :step="item.hsgMiniBuyQty"
              v-if="item.buyQty"
              disable-input
              @plus="changePlusTwo(item, row)"
              @minus="changMinusTwo(item, row)"
              :min="min || 0">
            </van-stepper>
            <div style="position: absolute;bottom: 3.3vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">
              <img :src="icon.addButton" style="width: 3.73vw">
            </div>
          </div>
        </div>
      </div>
<!--      购物车-->
      <span v-if="row.containerLoadGoodsList && row.containerLoadGoodsList[0] !== null && row.show" style="font-weight: 700">拼箱商品</span>
      <div v-if="row.containerLoadGoodsList && row.containerLoadGoodsList[0] !== null && row.show">
        <div v-for="item in row.containerLoadGoodsList" :key="item.id" style="width: 100%;height: 8vw;line-height: 8vw;position: relative;margin: 2vw 0 0">
          <span style="width: 8vw;height: 8vw;display: inline-block;position: absolute;top: 0vw">
            <img v-if="item.goodsImg || item.imgPath" :src="item.goodsImg || item.imgPath" style="width: 100%;height: 100%; -webkit-touch-callout: none; -webkit-user-select: none; user-select: none; ">
          </span>
          <span style="font-weight: 700;font-size: 3vw;margin-left: 10vw;width: 32vw;display: inline-block;overflow: hidden;display: inline-block;height: 7vw">{{item.goodsName}}</span>
          <span style="font-weight: 700;font-size: 3vw;position: absolute;left: 43vw">￥{{item.price/100}}</span>
          <div style="position: absolute; right: 4.8vw;bottom: 0vw;" class="shopListStepper">
            <van-stepper
              v-model="item.qty"
              input-width="6.67vw"
              button-size="3.73vw"
              integer
              :step="item.hsgMiniBuyQty"
              v-if="item.qty"
              disable-input
              @plus="changePlusTwo(item, row)"
              @minus="changMinusTwo(item, row)"
              :min="min || 0">
            </van-stepper>
            <div style="position: absolute;bottom: 3.3vw;right: 0vw;width: 4vw;height: 4vw" v-else @click.stop @click="changePlusTwo(item, row)">
              <img :src="icon.addButton" style="width: 3.73vw">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import addButton from '../../assets/img/icon/addButton.png'
import { ImagePreview } from 'vant'
export default {
  name: 'index',
  props: {
    row: Object,
    min: Number,
    source: Number
  },
  data () {
    return {
      icon: {
        addButton
      }
    }
  },
  methods: {
    expend (item) {
      this.$emit('expend', item)
    },
    // changePlus (item) {
    //   this.$emit('plus', item)
    // },
    // changMinus (item) {
    //   this.$emit('minus', item)
    // },
    showImg (img) {
      ImagePreview({
        images: [
          img
        ],
        closeable: true
      })
    },
    changePlusTwo (item, row) {
      this.$emit('plusTwo2', item, row)
    },
    changMinusTwo (item, row) {
      this.$emit('minusTwo2', item, row)
    }
  }
}
</script>

<style scoped>

</style>
